import { render, staticRenderFns } from "./StudentDutyStatusComponent.vue?vue&type=template&id=42fcfecb&"
import script from "./StudentDutyStatusComponent.vue?vue&type=script&lang=ts&"
export * from "./StudentDutyStatusComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42fcfecb')) {
      api.createRecord('42fcfecb', component.options)
    } else {
      api.reload('42fcfecb', component.options)
    }
    module.hot.accept("./StudentDutyStatusComponent.vue?vue&type=template&id=42fcfecb&", function () {
      api.rerender('42fcfecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/StudentDutyStatusComponent.vue"
export default component.exports